import {
  PEAK_SEASON_TYPE,
  THolidayConfigFormType,
  TPeakSeasonConfig,
} from 'features/configuration/types';
import dayjs from 'utils/moment/dayjsConfig';
import { ISO8601_FORMAT } from 'utils/moment/utils';

export const formatHolidayConfigFormValuesToPayload = (
  values: THolidayConfigFormType
) => {
  const formattedValues: TPeakSeasonConfig[] = [];

  try {
    for (const key in values) {
      const peaks = values?.[key as keyof THolidayConfigFormType];

      if (peaks) {
        const formattedPeaks = peaks?.map(item => {
          const { code, name, endTo, startFrom } = item || {};
          return {
            name,
            startFrom: dayjs(startFrom).format(ISO8601_FORMAT),
            endTo: dayjs(endTo).format(ISO8601_FORMAT),
            type:
              key === 'lunarDays'
                ? PEAK_SEASON_TYPE.LUNAR_HOLIDAY
                : PEAK_SEASON_TYPE.SOLAR_HOLIDAY,
            ...(code && { code }),
          };
        });
        formattedValues.push(...(formattedPeaks as TPeakSeasonConfig[]));
      }
    }
  } catch (e) {}

  return formattedValues;
};

export const formatPeaksResponseToFormValues = (
  values: TPeakSeasonConfig[]
) => {
  return values?.map(item => {
    const { endTo, startFrom, ...peakInfo } = item || {};
    return {
      ...peakInfo,
      startFrom: startFrom ? dayjs(startFrom, ISO8601_FORMAT) : undefined,
      endTo: endTo ? dayjs(endTo, ISO8601_FORMAT) : undefined,
    };
  });
};
